import Selectcontainers from "./components/SelectContainers.vue";
import Home from "./components/Home/Home.vue";
import Forms from "./components/SurveyForms/Forms.vue";
import ShoppingCart from "./components/ShoppingCart/ShoppingCart.vue";
import Quotes from "./components/Quotes.vue";
import PredeliveryForm from "./components/Predelivery/PredeliveryForm.vue";
import PrepickupForm from "./components/Pickup/PrepickupForm.vue";
import RTO_Qutoe from "./components/RTO_Quote.vue";

export const routes = [
    { path: '/', component: Home },
    { path: '/purchase', component: Selectcontainers },
    { path: '/purchase/container', component: Forms },
    { path: '/purchase/container/cart', component: ShoppingCart },
    { path: '/quote', component: Quotes },
    { path: '/rto_quote', component: RTO_Qutoe },
    { path: '/predeliveryform', component: PredeliveryForm },
    { path: '/prepickupform', component: PrepickupForm },
    { path: '*', redirect: '/' }
]